import { FaRobot, FaArrowRight } from "react-icons/fa";
import resumeData from "../../data/resumeData";

const AIFocusSection = () => (
  <section id="ai-focus" className="ai-feature-section py-14 text-white sm:py-16">
    <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
        <div>
          <p className="flex items-center gap-3 text-xs font-black uppercase tracking-[0.24em] text-teal-300">
            <FaRobot /> Applied AI
          </p>
          <h2 className="mt-3 text-3xl font-black leading-tight sm:text-4xl">
            AI work beside real delivery.
          </h2>
        </div>
        <p className="border-l-4 border-teal-300 pl-5 text-sm leading-7 text-stone-300">
          Hands-on RAG, agents, and tooling explored while shipping enterprise software — not theory in
          isolation.
        </p>
      </div>

      <div className="mt-8 grid gap-3 md:grid-cols-3">
        {resumeData.aiFocus.map((item, index) => (
          <article
            key={item.title}
            className="rounded-2xl border border-white/15 bg-white/[0.04] p-5"
          >
            <div className="flex items-start justify-between gap-3">
              <p className="text-xs font-bold uppercase tracking-wider text-teal-300">{item.status}</p>
              <span className="text-xs font-bold text-stone-500">0{index + 1}</span>
            </div>
            <h3 className="mt-3 text-lg font-bold leading-snug">{item.title}</h3>
            <p className="mt-3 text-sm leading-6 text-stone-300">{item.description}</p>
            <ul className="mt-4 flex flex-wrap gap-2">
              {item.tools.map((tool) => (
                <li
                  key={tool}
                  className="rounded-full border border-teal-300/20 bg-teal-300/10 px-2.5 py-1 text-[0.7rem] font-semibold text-teal-200"
                >
                  {tool}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-teal-300/20 bg-teal-300/5 px-5 py-4 text-teal-200">
        <p className="text-sm font-semibold">
          Live RAG demo on this site — BM25 retrieval, no API key, collapsed by default.
        </p>
        <a href="#ai-demo" className="inline-flex items-center gap-2 text-sm font-bold">
          Open demo <FaArrowRight />
        </a>
      </div>
    </div>
  </section>
);

export default AIFocusSection;
